import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Form, Input, Icon, Button, message } from "antd";
const FormItem = Form.Item;

class ChangePassword extends Component {
  state = {
    loading: false
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { oldPassword, newPassword } = values;
        Auth.currentAuthenticatedUser()
          .then(user => {
            return Auth.changePassword(user, oldPassword, newPassword);
          })
          .then(data => {
            message.success("Cambio de contraseña exitoso");
            this.setState({ loading: false });
          })
          .catch(error => {
            this.handleChangeErrors(error);
            this.setState({ loading: false });
          });
        this.props.form.resetFields(["oldPassword", "newPassword"]);
      } else {
        console.log(err);
        this.setState({ loading: false });
      }
    });
  };

  handleChangeErrors(error) {
    console.log(error);
    switch (error.code) {
      case "NotAuthorizedException":
        message.error("Contraseña incorrecta");
        break;
      case "LimitExceededException":
        message.error(
          "Excedió el límite de intentos, por favor intente más tarde"
        );
        break;
      case "InvalidParameterException":
        message.error(
          "El password debe tener una longitud mayor o igual a 8, al menos una mayusacula y un número"
        );
        break;
      default:
        message.error(error.message);
        console.log(error);
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormItem>
            {getFieldDecorator("oldPassword", {
              rules: [
                { required: true, message: "Ingresa tu contraseña actual" }
              ]
            })(
              <Input
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder="Contraseña actual"
              />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator("newPassword", {
              rules: [
                { required: true, message: "Ingresa tu nueva contraseña" }
              ]
            })(
              <Input
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder="Nueva contraseña"
              />
            )}
          </FormItem>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            loading={this.state.loading}
          >
            Cambiar contraseña
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(ChangePassword);



// WEBPACK FOOTER //
// ./src/Components/Profile/ChangePassword.js